// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { BadgeModel } from "@insite/client-framework/Types/ApiModels";
import FlexItem, { FlexItemProps } from "@insite/content-library/Widgets/Brand/FlexItem";
import FlexWrapContainer, { FlexWrapContainerProps } from "@insite/content-library/Widgets/Brand/FlexWrapContainer";
import Badge from "@insite/mobius/Badge";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

/* Starter Custom Code - Start */
import FlexWrapper, { FlexWrapperPresentationProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import { badgeProps } from "@store/Themes/common/props/badge";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
/* Starter Custom Code - End */

interface Props {
    badgeList: BadgeModel[];
    maxBadges: number;
    extendedStyles?: ProductImageBadgesStyles;
    numberOfColumns?: number;
    // Starter Custom Code
    useImageSizesStyles?: boolean;
}

export interface ProductImageBadgesStyles {
    container?: InjectableCss;
    imageContainer?: FlexWrapContainerProps;
    imageItem?: FlexItemProps;
    badgeImageProps?: JSX.IntrinsicElements["img"];
    image?: LazyImageProps;
    // Starter Custom Code
    flexWrapper?: FlexWrapperPresentationProps;
}

export const productImageBadgesStyles: ProductImageBadgesStyles = {
    flexWrapper: {
        gap: badgeProps.tagWrapper?.gap,
        extendedStyles: {
            wrapper: {
                css: css`
                    ${({ theme }) => {
                        const spacing = theme.design.product.detail.contentSpacing;
                        return spacingStyles(spacing, spacing);
                    }}
                `,
            },
        },
    },
};

const ProductImageBadges = ({
    badgeList,
    maxBadges,
    extendedStyles,
    numberOfColumns,
    // Starter Custom Code
    useImageSizesStyles = false,
}: Props) => {
    const [styles] = useState(() => mergeToNew(productImageBadgesStyles, extendedStyles));

    /* Starter Custom Code - Start */
    const smallImgProps = {
        style: {
            width: "50%",
            height: "auto",
        },
    };

    const mediumImgProps = {
        style: {
            width: "75%",
            height: "auto",
        },
    };

    const largeImgProps = {
        style: {
            width: "100%",
            height: "auto",
        },
    };

    return (
        <FlexWrapper
            {...styles.flexWrapper}
            itemsPerRow={[numberOfColumns ?? 4]}
            data-test-selector="productImageBadges"
        >
            {badgeList.slice(0, maxBadges).map(badge => (
                <Badge
                    key={badge.id}
                    type={badge.badgeType}
                    value={badge.largeImageBadgePath}
                    imageAltText={badge.imageAltText || badge.name}
                    imageBadgeProps={
                        !useImageSizesStyles
                            ? styles.badgeImageProps
                            : badge.detailWidgetBadgeSize === "Large"
                              ? largeImgProps
                              : badge.detailWidgetBadgeSize === "Small"
                                ? smallImgProps
                                : mediumImgProps
                    }
                />
            ))}
        </FlexWrapper>
    );
    /* Starter Custom Code - End */
};

export default ProductImageBadges;
